// import 'styles/equipmentHouse.scss'
// import 'styles/assessment.scss'
// import 'styles/equipmentHouseLincolnshire.scss'
import {Urls} from '../constants'
import { waitForElem } from '../utils/waitForElem';

(function () {
    /* global $ */
    "use strict";

    //let list = [];
    let currentState = {
        topLevelCategories: []
    }

    var isFirstPageTwoZoomCall = true; 
    var isFirstPageTwoZoomModalCall = true; 
    var isFirstMainContentCall = true; 
    var topValueSeeResultsButton;
    var topValueEditCategories;
    var topValueFinishPreview;  
    var minHeightMainContent;

    function heightMainContent() {

        if (isFirstMainContentCall) {
            // Variable initialization only for the first function call
            minHeightMainContent = parseFloat($('#maincontent').css('min-height'));       
    
            isFirstMainContentCall = false;  // Set the flag to false to prevent reinitialization
        }

        var zoomFont = parseFloat($('.pcg-page-wrapper').css('font-size'));

        if (zoomFont === 18) {

            $('#maincontent').css('min-height', (parseFloat(minHeightMainContent)+ 200) + 'px');

        } else if (zoomFont === 20) {

            $('#maincontent').css('min-height', (parseFloat(minHeightMainContent) + 400) + 'px');

        } else{

            $('#maincontent').css('min-height', parseFloat(minHeightMainContent) + 'px');

        }

    
    }

    heightMainContent();

    $('body').on('click', '.js-accessibility-widget__font-size', function(){
        heightMainContent();
    })
    
    function pageOneActions(){

        // Retain the selected class on tiles if moving between pages
        $('.eq-tile-checklist .form-checkbox__option').each(function(){

            if ( $(this).find('input').is(":checked") ) {
                $(this).addClass('selected');
            }
        });
        printOutCategoriesInFooter();

    }

    

    function pageTwoActions() {

        // Remove Page 1 specific stuff
        $('.js-continue-with-container').remove();

        $('.eq-progress-container p').html(
            `
                <div class="progress-container-parent js-progress-container-parent">
                    <div class="js-progress-container progress-div" id="progress-div-page-2"></div>
                </div>
                
            `
        );

        // Hide subcategories if they are shown
        if ($('.eq-content-questions').length > 0) {
            $('.eq-content-questions').hide()
        }

        // Move edit-categories button to the top for mobile versions
        $('.answer-btns').addClass('edit-categories-top')

        if ($('.js-cancel-button').length > 0) {
            $('.js-cancel-button').hide()
        }


        // Change h1 and h2 content for page-2
        $('.form-header__title').text(`Tell us more...`)
        $('.form-header__description').text(`Click on a category to see different options. If you need to change your selection, click 'Edit categories'.`)
        // $('fieldset legend').hide()

        // Change tab index for page-2  
        $('.page-2 .form-header__title').focus()

        // Scroll top 
        $(window).scrollTop(0);

        pageTwoTabs();
        pageTwoContinueNextSteps();
        pageTwoNavigation();
        pagePreview();
    }

    function pageDumyResultsActions() {

        $('.pop-up-finish-container').hide();
        $('.cancel-button').hide()
        $('.see-results-button').css('top', 0);
        $('.see-results').hide();
        $('.see-results').removeClass('see-results-button');
        $('.finish-preview-container').hide()
        $('.question-type-label').parent().parent().parent().css('pointer-events', 'auto')
        $('.question-type-label').parent().parent().parent().addClass('form-content')

        if ( $('.results-added-text').length == 0) {
            $('.form-content').prepend('<div class="page-title"><strong>Your Results:</strong><p class="results-added-text">Based on your choices, we believe the following information may help you and national organisations in your area.</p></div>')

        }

        $('.form-app').append(
            `<div class="side-section">
                        <div class="side-section-content">
                            <div class="side-section-content-title">National Organisations</div>
                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/age-uk.png"></div>
                                    <div><p><strong>Age UK</strong><br>Website:<a href="https://www.ageuk.org.uk/" target="_blank"> https://www.ageuk.org.uk/</a><br>Advice Line:<a href="tel:0800 678 1602" target="_blank"> 0800 678 1602</a></p></div>
                                </div>
                                <div class="side-section-content-text">Age UK's Advice Line is a free, confidential national telephone service for older people, as well as their families, friends, carers and professionals. Our team will give you information that's reliable and up to date and help you access the advice you need.</div>
                            </div>

                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/alzheimer3.png"></div>
                                    <div><p><strong>Alzheimer’s Society</strong><br>Website:<a href="https://www.alzheimers.org.uk/" target="_blank"> https://www.alzheimers.org.uk/</a><br>Phone Number:<a href="tel:0333 150 3456" target="_blank"> 0333 150 3456</a></p></div>
                                </div>
                                <div class="side-section-content-text">At Alzheimer’s Society we’re working towards a world where dementia no longer devastates lives. We do this by giving help to those living with dementia today, and providing hope for the future.</div>
                            </div>

                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/stroke.svg"></div>
                                    <div><p><strong>Stroke Association</strong><br>Website:<a href="https://www.stroke.org.uk/" target="_blank"> https://www.stroke.org.uk/</a><br>Stroke Helpline:<a href="tel:0303 3033 100" target="_blank"> 0303 3033 100</a></p></div>
                                </div>
                                <div class="side-section-content-text">We're here to support people to rebuild their lives after a stroke. We believe everyone deserves to live the best life they can after a stroke. <br>
                                We provide specialist support, fund critical research and campaign to make sure people affected by stroke get the very best care and support to rebuild their lives.</div>
                            </div>
                        </div>
                    </div>`
        )

        $('.question-type-label h2').each(function(){

            $(this).parent().parent().addClass('item-header')

            $(this).parent().parent().next().children().children().first().addClass('item-first')
        
            $(this).parent().parent().prev().children().children().last().addClass('item-last')         
           
        })


        $('.question-type-singlecheckbox h3').each(function(){

            if ($(this).text() === 'Would you like to email a copy of these results to yourself?') {
                $(this).parent().parent().prev().children().children().last().addClass('item-last')
                $(this).next().hide()
            }   else if ($(this).text() === 'I would like to email a copy of these results to myself') { 
                $(this).parent().parent().prev().children().children().last().addClass('item-last')
                $(this).next().hide()
            }   
           
        })

        // Change h1 and h2 content for dumy-results-page
        $('.form-header__title').text(`Your Results:`)
        $('.form-header__description').text('Based on your choices, we believe the following information may help you and national organisations in your area.')
        $('.page-title').hide()


        // Change opacity from 0.5 to 1 from previous step (page-2)
        $('.eq-content-questions__parent').css('opacity', '1')
        $('.eq-content-container__parent').css('opacity', '1')
        $('.finish-preview-container').css('opacity', '1')
        $('.eq-progress-container__header').css('opacity', '1')
        $('.form-main').css('pointer-events', 'auto')
        $('.form-header').css('pointer-events', 'auto')
        $('.form-main').css('opacity', '1')
        $('.form-header').css('opacity', '1')

        // Change tab index for page-dumy-results

        $('.page-dumy-results .form-header__title').focus()

        $('.page-dumy-results .item-header h2').each(function(){
            $(this).attr('tabindex', 0);
        })  

        $('.page-dumy-results .question-type-label h3').each(function(){
            $(this).attr('tabindex', 0);
        })  

        $('.page-dumy-results .question-type-label ul li').each(function(){
            $(this).attr('tabindex', 0);
        }) 

        $('.page-dumy-results .question-type-singlecheckbox').each(function(){
            $(this).attr('tabindex', 0);
        }) 

        $('.page-dumy-results .question-type-singlecheckbox label').each(function(){
            $(this).attr('tabindex', 0);
        }) 

        $('.page-dumy-results .question-type-radio legend h3').each(function(){
            $(this).attr('tabindex', 0);
        }) 

        $('.page-dumy-results .question-type-radio .form-radio__option label').each(function(){
            $(this).attr('tabindex', 0);
        }) 

        $('body').on('keyup', '.page-dumy-results .question-type-singlecheckbox label ', function(e){
            if (e.which === 13) {
                // $(".page-dumy-results .question-type-email input").attr("placeholder", "Enter email address..");
                $(this).click();
            }
        });

        $('body').on('keyup', '.page-dumy-results .form-radio__option label', function(e){
            if (e.which === 13) {
                $(this).click();
            }
        });
        
        

        $('body').on('change', '.page-dumy-results .question-type-singlecheckbox input', function(){
            $(".page-dumy-results .question-type-email input").attr("placeholder", "Enter email address..");
        })

        $('body').on('change', '.form-radio__option input', function(){
            if($('.page-dumy-results').length !== 0 ) {
                if ($(this).next('label').text()==='Yes') {
                    $('.see-results').text('Complete your online assessment')
                    $('.see-results').show();
                    $('.cancel-button').prev().prev().hide()
    
                } else if ($(this).next('label').text()==='No') {
                    $('.cancel-button').prev().prev().show()
                    $('.see-results').hide();
                }
            }

            $(this).next().blur();
        });     


    }

    function pageResultsActions() {

        $('.side-section').remove()
     
        var checkExistApp = setInterval(function () {

            if ($('table').length > 0) {
                clearInterval(checkExistApp);

                // Check to see if td has any content. If not remove them
                $('tr').each(function(){
                    if (!$(this).text().trim().length) {
                        $(this).remove(); // This may cause bugs so consider only hiding
                    }           
                });

                $('strong').each(function(){
                    $(this).parent().parent().parent().parent().addClass('header-div')
                    $(this).parent().addClass('eq-results-page-header')
                })

              
                $('tr').each(function(){
                    if (!$(this).hasClass('header-div')) {
                        $(this).addClass('content-div')
                    }
                })

                $('.header-div:first-child').addClass('eq-results-title-container');
                $('.header-div:first-child').children().children().children().removeClass('eq-results-page-header')
                $('.eq-results-title-container').removeClass('header-div');
                $('.eq-results-title-container').removeClass('content-div');

                
                $('.header-div').next('tr').addClass('content-div-first-child');
                // $('table tr:first-child').addClass('content-div-first-child');

                $('.header-div').prev('tr').addClass('content-div-last-child');
                $('table tr:last-child').addClass('content-div-last-child');

                $('table').attr('border', '0');
                $('table').attr('cellpadding', '0');
                $('table').attr('cellspacing', '0');


                if ( $('.results-added-text').length == 0) {
                    $('strong:contains("Your Results:")').append('<p class="results-added-text">Based on your choices, we believe the following information may help you and national organisations in your area.</p>')

                }

            //     // $('div:contains("Your Results")').text('Your results');

            };

            if ($('.js-exit').length === 0 ) {      
                              
                $('table').parent().append(
                    `<div class="side-section">
                        <div class="side-section-content">
                            <div class="side-section-content-title">National Organisations</div>
                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/age-uk.png"></div>
                                    <div><p><strong>Age UK</strong><br>Website:<a href="https://www.ageuk.org.uk/" target="_blank"> https://www.ageuk.org.uk/</a><br>Advice Line:<a href="tel:0800 678 1602" target="_blank"> 0800 678 1602</a></p></div>
                                </div>
                                <div class="side-section-content-text">Age UK's Advice Line is a free, confidential national telephone service for older people, as well as their families, friends, carers and professionals. Our team will give you information that's reliable and up to date and help you access the advice you need.</div>
                            </div>

                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/alzheimer3.png"></div>
                                    <div><p><strong>Alzheimer’s Society</strong><br>Website:<a href="https://www.alzheimers.org.uk/" target="_blank"> https://www.alzheimers.org.uk/</a><br>Phone Number:<a href="tel:0333 150 3456" target="_blank"> 0333 150 3456</a></p></div>
                                </div>
                                <div class="side-section-content-text">At Alzheimer’s Society we’re working towards a world where dementia no longer devastates lives. We do this by giving help to those living with dementia today, and providing hope for the future.</div>
                            </div>

                            <div class="side-section-content-item">
                                <div class="side-section-content-details">
                                    <div class="side-section-content-details-img"><img src="/resources/Councils/TowerHamlets/assets/images/stroke.svg"></div>
                                    <div><p><strong>Stroke Association</strong><br>Website:<a href="https://www.stroke.org.uk/" target="_blank"> https://www.stroke.org.uk/</a><br>Stroke Helpline:<a href="tel:0303 3033 100" target="_blank"> 0303 3033 100</a></p></div>
                                </div>
                                <div class="side-section-content-text">We're here to support people to rebuild their lives after a stroke. We believe everyone deserves to live the best life they can after a stroke. <br>
                                We provide specialist support, fund critical research and campaign to make sure people affected by stroke get the very best care and support to rebuild their lives.</div>
                            </div>
                        </div>
                        <div><button class="js-exit exit">Exit Assessment</button></div>
                    </div>`
                );               

                // Change tab index for page-results  

                $('.page-results .form-header__title').attr('tabindex', 0);

                $('.page-results .form-header__description').attr('tabindex', 0);

                $('.page-results .form-header__title').focus()

                $('.page-results .eq-results-page-header').each(function(){
                    $(this).attr('tabindex', 0);
                })  

                $('.page-results .content-div span').each(function(){
                    $(this).attr('tabindex', 0);
                })  

                $('.page-results .content-div  ul li').each(function(){
                    $(this).attr('tabindex', 0);
                }) 

                $('.page-results .js-exit').attr('tabindex', 0);        

            } 

            

            $('body').on('click', '.js-exit', function(){
                location.reload()
            })

           

        }, 200); // check every 200ms

        


    }

    function pageAssessmentResultsTabs(){
        // Change tab index for page-assessment-result  
        $('.page-assessment-results .form-main__questions-container').attr('tabindex', 0)
       
        $('.page-assessment-results .form-main__questions-container .question-type-label h2').attr('tabindex', 0)
        $('.page-assessment-results .form-main__questions-container .question-type-label h2').focus()
        $('.page-assessment-results .form-main__questions-container .question-type-label p').attr('tabindex', 0)
        $('.page-assessment-results .form-main__questions-container .question-type-radio p').attr('tabindex', 0)
        $('.page-assessment-results .form-main__questions-container .form-radio__option label').each(function(){
            $(this).attr('tabindex', 0)
        })
        $('.page-assessment-results .form-main__questions-container .form-checkbox__option label').each(function(){
            $(this).attr('tabindex', 0)
        })

        // $('.page-assessment-results .form-main__questions-container').find('*').attr('tabindex', '0');
        $('body').on('keyup', '.page-assessment-results .form-radio__option', function(e){
            if (e.which === 13) {
                $(this).children('label').click()
    
                $('.page-assessment-results .form-main__questions-container').attr('tabindex', 0)
                $('.page-assessment-results .form-main__questions-container .question-type-label h2').attr('tabindex', 0)
                $('.page-assessment-results .form-main__questions-container .question-type-label p').attr('tabindex', 0)
                $('.page-assessment-results .form-main__questions-container .question-type-radio p').attr('tabindex', 0)
                $('.page-assessment-results .form-main__questions-container .form-radio__option label').each(function(){
                    $(this).attr('tabindex', 0)
                })
                $('.page-assessment-results .form-main__questions-container .form-checkbox__option label').each(function(){
                    $(this).attr('tabindex', 0)
                })
            }
        });

        $('body').on('keyup', '.page-assessment-results .form-checkbox__option', function(e){
            if (e.which === 13) {
                $(this).find('label').click();
            }
        });

    }

    function pageAssessmentResultsActions() {
        $('button.blockBtns:contains("Complete your online assessment")').text('Next');
        $('button.blockBtns:contains("Next")').show();
        $('button.blockBtns:contains("Next")').next().hide()
        // $('button.blockBtns:contains("Next")').prev().show()
        $('button.blockBtns:contains("Next")').prev().addClass('prev-btn')
        // $('.answer-btns').addClass('prev-btn-container');
        $('h2').each(function(){
            if ($(this).text("Introduction")) {
                 $(this).addClass('introduction')
            }           
        })

        $('.form-header__title').text('Assessment')
        $('.form-header__description').text(`${$('.form-main p > h2').text()}`)

        $('body').on('change', '.form-radio__option input', function(){
            $(this).next().blur()
        });

        

        setTimeout(() => {
            $('.question-type-label').each(function(){
                $(this).removeClass('mar-bot1')
            })
        }, 500);


        // Change tab index for page-assessment-result  
        pageAssessmentResultsTabs()
           



        $('body').on('click', '.answer-btns button', function(){
            if ( $(this).text().match('Next') ) {

                $(window).scrollTop(0);

                $('.question-type-label').each(function(){
                    $(this).removeClass('mar-bot1')
                })

                // Here it should be choosen another method for hide Previous button for the first step
                $('.question-type-label').each(function(){
                    if($(this).attr("data-qst-id") == '920a2e85-b98c-4e8f-a444-ae168d0f56e3' ){
                        $('.prev-btn').hide();
                        $('.answer-btns').removeClass('prev-btn-container');
                    } else {
                        $('.prev-btn').show();
                        $('.answer-btns').addClass('prev-btn-container');
                    }
                })

                $('.form-header__title').text('Assessment')
                $('.form-header__description').text(`${$('.form-main p > h2').text()}`)

                $('body').on('change', '.form-radio__option input', function(){
                    $(this).next().blur()
                });
    
                $('body').on('keyup', '.page-assessment-results .form-checkbox__option', function(e){
                    if (e.which === 13) {
                        $(this).find('label').click();
                    }
                });

                pageAssessmentResultsTabs()
            }

            if ( $(this).text().match('Previous') ) {

                $(window).scrollTop(0);

                $('.question-type-label').each(function(){
                    $(this).removeClass('mar-bot1')
                })

                // Here it should be choosen another method for hide Previous button for the first step
                $('.question-type-label').each(function(){
                    if($(this).attr("data-qst-id") == '920a2e85-b98c-4e8f-a444-ae168d0f56e3' ){
                        // if ($('#920a2e85-b98c-4e8f-a444-ae168d0f56e3').length !==0) {
                        $('.prev-btn').hide();
                        $('.answer-btns').removeClass('prev-btn-container');
                    } else {
                        $('.prev-btn').show();
                        $('.answer-btns').addClass('prev-btn-container');
                    }
                })

                $('.form-header__title').text('Assessment')
                $('.form-header__description').text(`${$('.form-main p > h2').text()}`)

                $('body').on('change', '.form-radio__option input', function(){
                    $(this).next().blur()
                });        

                $('body').on('keyup', '.page-assessment-results .form-checkbox__option', function(e){
                    if (e.which === 13) {
                        $(this).find('label').click();
                    }
                });

                pageAssessmentResultsTabs()

            }
        })


        
    }

    function printOutCategoriesInFooter() {

        $('.js-continue-with-container').remove();

        if ( currentState.topLevelCategories.length === 0 ) {
            $('.js-continue-with-container').remove();

        } else {
            $('.page-1 .answer-btns').append(
                `<div class="js-continue-with-container continue-with-container"><p class="heading">Continue with:</p><div class="js-continue-with continue-with"></div></div>`
            );

            currentState.topLevelCategories.forEach(function(obj){
                $('.js-continue-with').append(
                    `
                        <span>${obj.name}</span>
                    `
                )
            });
        }
    } 

    

    function pageTwoTabs() {

        currentState.topLevelCategories.forEach(function(currentElement){

            $('.js-progress-container').append(
                `
                    <button class="js-tab-buttons" data-index="${currentElement.index - 1}">${currentElement.name}</button>
                `
            );
        });

        if ($('.js-tab-buttons').length===1) {
            $('.progress-div').addClass('remove-mask')    
        } else if ($('.js-tab-buttons').length===2){
            $('.progress-div').removeClass('remove-mask') 
            $('.progress-div').addClass('remove-mask-for-2')   
        } else {
            $('.progress-div').removeClass('remove-mask remove-mask-for-2') 
            $('.progress-div').addClass('mask-end')
        }


        // Scrollable div
        const scrollableDiv = document.getElementById("progress-div-page-2");

        // Add a scroll event listener to the div
        scrollableDiv.addEventListener("scroll", function() {
            // Get the full width of the scrollable content
            const fullWidth = scrollableDiv.scrollWidth;
       
            // Get the width of the visible portion
            const visibleWidth = scrollableDiv.clientWidth;

            // Check if the div is scrolled to the right
            if (scrollableDiv.scrollLeft > 0) {
                $('.progress-div').removeClass('mask-end, mask-start')
                // Check if the scroll has reached the end
                if (scrollableDiv.scrollLeft >= fullWidth - visibleWidth) {
                    $('.progress-div').addClass('mask-start')
                    $('.progress-div').removeClass('mask-end')
                } else {
                    $('.progress-div').removeClass('mask-end')
                }
            } else if (scrollableDiv.scrollLeft === 0)  {
                $('.progress-div').addClass('mask-end')
                $('.progress-div').removeClass('mask-start')
            }
        });


        // CTA

        $('.js-tab-buttons').click(function(){

            // Add the visited class after a button has been selected
            
            $('.js-tab-buttons').each(function(i){
                
                if ( $(this).hasClass('active-button') ) {
                    $(this).addClass('visited');
                }

                $(this).attr('id', i)
            });

            
            const thisIndex = $(this).attr('data-index');
            const thisId = $(this).attr('id');
            var marginLeft = 0;

            for (let i=0; i<thisId; i++) {
                if ($('.js-tab-buttons')[i].offsetWidth !== undefined) {
                    marginLeft+=  $('.js-tab-buttons')[i].offsetWidth;
                    $('.progress-div').scrollLeft(marginLeft);
                }   
            }

            
            $('.eq-content-container').hide();
            $('.eq-content-container').eq(thisIndex - 1).show();

            $('.js-tab-buttons').removeClass('selected');
            $('.js-tab-buttons').addClass('deselected');
            $(this).removeClass('deselected');
            $(this).addClass('selected');

            $(this).addClass('active-button');

            // Change tab index for page-2
            $('.page-2 .eq-content-container .form-radio__option label').each(function(){
                $(this).attr('tabindex', 0);
            })

            $('.page-2 .eq-content-container .form-checkbox__option label').each(function(){
                $(this).attr('tabindex', 0);
            })

           
            // Change tab index for page-2
            $('body').on('keyup', '.page-2 .form-checkbox__option', function(e){
                if (e.which === 13) {
                    $(this).children('label').click()
                }
            });
            $(this).blur()
            
            // Remove the overlay from questions
            $('.eq-content-questions').removeClass('blockedContent');
            $('.eq-content-container').removeClass('blockedContent');
            $('.blockedContentYellow').removeClass('blockedContentYellow')
            $('.blockedContentBlack').removeClass('blockedContentBlack')

        });

    }

    function pageTwoContinueNextSteps() {

        let thisIndex;
        let thisText;
        let thisButton;
        let nextTab = 'InitialValue';

        $('.edit-categories-top').parent().append(
            `<div class="section finish-preview-container"><div class="col"><div><button class="js-finish-preview finish-preview">Finish and see results</button></div></div></div>`
        );

        $('.eq-progress-container').parent().addClass('eq-progress-container__header');

        $('body').on('keyup', '.js-tab-buttons', function(e){
            // Change tab index for page-2
            $('body').on('keyup', '.page-2 .form-checkbox__option', function(e){
                if (e.which === 13) {
                    $(this).children('label').click()
                }
            });
        });

        // Add class for selected content container
        // $('.js-tab-buttons').each(function(){
        //     $('.eq-content-container').eq($(this).attr('data-index')-1).addClass('js-eq-content-container-visible');
        // })
     
        

        $('body').on('click', '.js-tab-buttons', function(){

            // Resets
            $('.eq-content-questions').hide() // Hide all question containers
            $('.eq-content-questions').removeClass('eq-content-questions__parent'); // Remove parent class of all 3rd level question containers

            thisIndex = $(this).attr('data-index');
            thisText = $(this).text();
            $('.eq-content-container').eq(thisIndex - 1).addClass('js-eq-content-container-' + thisIndex);         

            // Remove activated class
            $('.form-checkbox__option label').each(function(){
                if ($(this).hasClass('activated')){
                    $(this).removeClass('activated');
                }
            });
            

            // Add class on 2nd level parents for styling
            $('.eq-content-container').removeClass('eq-content-container__parent');
            $('.eq-content-container').each(function(){
                if ( $(this).is(':visible')  ) {
                    $(this).addClass('eq-content-container__parent');
                }
            })

            $('.eq-content-container .form-radio__option').each(function(){
                if ( $(this).is(':visible')  ) {
                    if ( $(this).find('input').is(":checked") ) {
                        $(this).children().first().prop('checked', false);
                    }

                }
            })


            // Add visited-checkbox class for visited checkboxes
            $('.eq-content-container__parent .form-checkbox__option label').each(function(){
                if ($(this).prev().is(':checked')){
                    $(this).addClass('visited-checkbox')
                }
            })

            $('body').on('click', '.eq-content-container__parent .form-checkbox__option label', function(event) {
                // Remove the 'activated' class from all elements except the clicked one
                $('.eq-content-container__parent label.activated').not(this).removeClass('activated');

                // Add the 'activated' class to the clicked element
                $(this).addClass('activated');

                // Add visited-checkbox class for visited checkboxes
                setTimeout(() => {
                    $(this).addClass('visited-checkbox');
                }, 1000);
               
                // Hide all content question containers
                $('.eq-content-questions').each(function() {
                    $(this).hide();
                });  



            });


            // Add click event for visited checkboxes
            $('body').on('click', '.eq-content-container__parent .form-checkbox__option .visited-checkbox', function() {
                if (!$(this).data('clicked')) {
                    $(this).data('clicked', true);
                    setTimeout(() => {
                        $(this).click();
                        $(this).data('clicked', false);
                    }, 100);
                }
            });  
                     
            // Add class on 3rd level categories
            $('body').on('change', '.eq-content-container__parent input', function(){

                $('.eq-content-questions').each(function(){
                    if ( $(this).is(':visible')  ) {
                        $(this).addClass('eq-content-questions__parent');
                    }                     
                    // Change tab index for page-2
                    $(this).attr('tabindex', 0);
                    $('.page-2 .eq-content-questions .form-checkbox__option').each(function(){
                        $(this).attr('tabindex', 0);
                    })

                })


                // $(this).next().blur()

            });


            // Change tab index for page-2
            $('body').on('keyup', '.page-2 .form-checkbox__option', function(e){
                if (e.which === 13) {
                    $(this).children('label').click()
                }
            });
            
            
            $('.js-continue-to-next-step').remove();

            $('.js-progress-container').after(
                //$('.js-eq-content-container-' + thisIndex).prepend(
                    `
                        <div class="js-continue-to-next-step continue-next-step">
                            <div class="js-continue-to-next-step-text continue-to-next-step-text">
                                <p>Click the options below to select the areas of support you require.</p>
                            </div>
                        </div>
                    `
                );


            // Ignore if all steps are finished
            if ( nextTab !== 'All complete') {

                thisButton = '.eq-content-questions input';
                $('body').on('change', thisButton, function(){


                    // Find the next available non visited tab
                    nextTab = $('.js-progress-container').find('button:first-child');
                    if ( $(nextTab).hasClass('selected') || $(nextTab).hasClass('visited') ) {
                        nextTab = $('.js-progress-container').find('button:first-child').nextAll('button').not('.visited').not('.selected').first();

                        if ( $(nextTab).text() == '') {
                            nextTab = 'All complete';
                        }
                    }

                    // Create confirm finish
                    $('.js-continue-to-next-step-button').remove();

                    // if ( nextTab !== 'All complete') {
                        
                        $('.js-continue-to-next-step-text').after(
                        //$('.js-eq-content-container-' + thisIndex).prepend(
                            `
                                <div class="js-continue-to-next-step-button continue-to-next-step-button"">
                                    <p>Finished '${thisText}?'</p>
                                    <button class="js-section-finished-btn">Yes</button>
                                </div>
                            `
                        );
                    // }
                    // Change tab index for page-2                    
                    $('.page-2 .js-continue-to-next-step-button').attr('tabindex', 0)
                    $('.page-2 .js-continue-to-next-step-button').focus()
                    $('.page-2 .js-section-finished-btn').attr('tabindex', 0)

                    // Finished with this section
                    $('.js-section-finished-btn').click(function(){
                        const nextTabIndex = $(nextTab).attr('data-index');
                        const nextTabText = $(nextTab).text();


                        // Add class for selected content container
                        // $('.js-tab-buttons').each(function(){
                        //     $('.eq-content-container').eq($(this).attr('data-index')-1).addClass('js-eq-content-container-visible');
                        // })

                        if (nextTabText !== '') {
                            $('.js-continue-to-next-step-button').html(
                                `
                                   
                                        <p>Continue to '${nextTabText}?'</p>
                                        <button class="js-section-finished-confirmed-btn">Yes</button>
                                        <button class="js-remove-blocker">Cancel</button>
                                    
                                `
                            )


                            // Create the overlay
                            $('.eq-content-questions').addClass('blockedContent');
                            $('.eq-content-container').addClass('blockedContent');

                            // Confirm click and go to the next tab
                            $('.js-section-finished-confirmed-btn').click(function(){
                                $('.eq-content-questions').hide() // Hide all question containers
                                $('.eq-content-questions').removeClass('blockedContent');
                                $('.eq-content-container').removeClass('blockedContent');
                                $('.blockedContentYellow').removeClass('blockedContentYellow')
                                $('.blockedContentBlack').removeClass('blockedContentBlack')
                                $('.js-tab-buttons[data-index="' + nextTabIndex + '"]').click();
                            });

                            // Cancel the overlay
                            $('.js-remove-blocker').click(function(){
                                $('.eq-content-questions').removeClass('blockedContent');
                                $('.eq-content-container').removeClass('blockedContent');
                                $('.blockedContentYellow').removeClass('blockedContentYellow')
                                $('.blockedContentBlack').removeClass('blockedContentBlack')
                                $('.js-continue-to-next-step-button').html(``)
                            })

                        } else {
                            $('.eq-content-questions').hide() // Hide all question containers
                            $('.eq-content-questions').removeClass('blockedContent');
                            $('.eq-content-container').removeClass('blockedContent');
                            $('.blockedContentYellow').removeClass('blockedContentYellow')
                            $('.blockedContentBlack').removeClass('blockedContentBlack')
                            $('.js-tab-buttons[data-index="' + thisIndex + '"]').click();
                            $('.js-continue-to-next-step-button').html('')
                        }


                        // Change tab index for page-2        
                        $('.page-2 .js-continue-to-next-step-button').attr('tabindex', 0)
                        $('.page-2 .js-section-finished-confirmed-btn').attr('tabindex', 0)
                        $('.page-2 .js-remove-blocker').attr('tabindex', 0)
                    })
                });

            } else {
                $('.js-continue-to-next-step').remove();
                $('.js-finish-preview').removeClass('deselected')
                // Change tab index for page-2  
                $('.page-2 .js-finish-preview').focus()
                $('.page-2 .js-finish-preview').blur()
            }

        }); 
        
        // Change tab index for page-2
        $('body').on('keyup', '.page-2 .form-radio__option', function(e){
            if (e.which === 13) {
                $(this).children('label').click()
            }
        });

        $('body').on('keyup', '.page-2 .form-checkbox__option', function(e){
            if (e.which === 13) {
                $(this).children('label').click()
            }
        });

        $('.js-finish-preview').addClass('deselected')

        // $('body').on('click', '.eq-content-container input', function(e){
        //     e.preventDefault();

        //     const parentContainer = $(this).closest('.eq-content-container');

        //     if ( $(this).is(":checked") ) {

        //         $(this).click();
            
        //     } else {

        //         $(parentContainer)
        //     }

        // });
    }

    function pageTwoNavigation() {
        //const previousBtn = $('.answer-btns').clone();
        //const previousBtn = $('.answer-btns button:contains("Previous")').clone();
        //$('.js-progress-container').append(previousBtn)

        $('button.blockBtns:contains("Previous")').addClass('edit-categories');
        // $('button.blockBtns:contains("Finish and see results")').text('Yes, see my results');
        // $('button.blockBtns:contains("Yes, see my results")').addClass('see-results');
        // $('button.blockBtns:contains("Yes, see my results")').hide();
        $('.edit-categories').parent().parent().addClass('action-buttons-container')
        $('button.blockBtns:contains("Next")').hide();
        // $('button.blockBtns:contains("Next")').next().text('Yes, see my results');
        // $('button.blockBtns:contains("Next")').next().addClass('see-results');

       
        // $('button.blockBtns:contains("Next")').text('Yes, see my results');
        // $('button.blockBtns:contains("Next")').addClass('see-results');
        // $('button.blockBtns:contains("Next")').next().hide();

                

        $('body').on('click', '.edit-categories', function(){
            $('.finish-preview-container').remove();
            $('button.blockBtns:contains("Next")').show();
                                  
            // Change h1 and h2 content for page-1
            $('.form-header__title').text(`Let's begin`)
            $('.form-header__description').text('What are you looking for support with? Choose from the categories below to tell us where you need help or advice. You can choose as many categories as you like')
            $('.question-type-checkboxlist fieldset legend').hide()

            // Change tab index for page-1  
            // $('.form-header__title').focus()
            $('.page-1 .eq-tile-checklist .form-checkbox__option').each(function(){
                $(this).attr('tabindex', 0);
            })
            $('.page-1 .form-header__title').focus()

        })


 
    }

    function pagePreview() {
        // $('.progress-container-parent').hide();
        // $('.eq-content-container__parent').hide();
        // $('.eq-content-questions__parent').hide();

        if ($('.pop-up-finish-container').length === 0) {
            $('.answer-btns').prepend(
                `<div class="section pop-up-finish-container"><div class="col span_12_of_12"><div class="pop-up-finish"><h2>Lets double check</h2><p><strong>Are you sure you have gone through all the areas that you need help in?</strong></p><p>Once you have confirmed you won't be able to edit your answer and will need to retake the assessment again.</p></div></div></div>`
            );
    
            $('.answer-btns').append(
                `<button class="js-cancel-button cancel-button">No, need more help</button>`
            );
    
            $('.cancel-button').hide()
        } 
        

        function pageTwoZoom() {

            if (isFirstPageTwoZoomCall) {
                // Variable initialization only for the first function call
                topValueEditCategories = parseFloat($('.answer-btns').css('top'));
                topValueFinishPreview = parseFloat($('.finish-preview-container').css('top'));
            
        
                isFirstPageTwoZoomCall = false;  // Set the flag to false to prevent reinitialization
            }

            var zoomFont = parseFloat($('.pcg-page-wrapper').css('font-size'));

            if (zoomFont === 18) {

                $('.answer-btns').css('top', (parseFloat(topValueEditCategories)+ 21) + 'px');
                $('.finish-preview-container').css('top', (parseFloat(topValueFinishPreview) + 21) + 'px');

            } else if (zoomFont === 20) {

                $('.answer-btns').css('top', (parseFloat(topValueEditCategories) + 42) + 'px');
                $('.finish-preview-container').css('top', (parseFloat(topValueFinishPreview) + 42) + 'px');

            } else{

                $('.answer-btns').css('top', parseFloat(topValueEditCategories) + 'px');
                $('.finish-preview-container').css('top', parseFloat(topValueFinishPreview) + 'px');

            }

        
        }

        pageTwoZoom();

        $('body').on('click', '.js-accessibility-widget__font-size', function(){
            pageTwoZoom();
        })

        $('body').on('click', '.js-fontsize-normal', function(){
            pageTwoZoom();
        })

        $('body').on('click', '.js-fontsize-medium', function(){
            pageTwoZoom();
        })

        $('body').on('click', '.js-fontsize-large', function(){
            pageTwoZoom();
        })



    
        // $('.answer-btns').append(
        //     `<div class="section"><div class="col span_12_of_12"><div><button class="js-close-button close-button">Close</button></div></div></div>`
        // );

        $('.pop-up-finish-container').hide();
        
        $('.js-finish-preview').click(function(){
            $('.pop-up-finish-container').show();
            $('button.blockBtns:contains("Next")').addClass('see-results');
            $('button.blockBtns:contains("Next")').text('Yes, see my results');
            $('.see-results').show();
            $('.see-results').addClass('see-results-button js-see-dumy-results');
            $('.edit-categories-top').addClass('pop-up-main')
            $('.edit-categories').hide();
            $('.cancel-button').show()
            $('.eq-content-questions__parent').css('opacity', '0.5')
            $('.eq-content-container__parent').css('opacity', '0.5')
            $('.finish-preview-container').css('opacity', '0')

            $('.form-main').css('opacity', '0.5')
            $('.form-header').css('opacity', '0.5')

            $('.eq-progress-container__header').css('opacity', '0.5')
            $(window).scrollTop(0);

            // Disable click for the rest of the elements, except modal window
            // $('.eq-progress-container__header').parent().parent().css('pointer-events', 'none')
            $('.form-main').css('pointer-events', 'none')
            $('.form-header').css('pointer-events', 'none')

            // $('button.blockBtns:contains("Next")').next().show();


            //  Removed deleted checkboxes
            $('.js-tab-buttons').each(function(){
                let currentButtonText = $(this).text().toLowerCase();
                $('.eq-content-container legend').each(function(){
                    if (currentButtonText !== $(this).text().toLowerCase()){
                        $(this).parent().find('input').each(function(){
                            
                            if ($(this).prop('checked')) {
                                // console.log($(this).next().text())
                                // $(this).prop('checked',false)
                                console.log($(this))
                            } 
                        })
                    }
                });
            });
            
            
            

            // $('.js-finish-preview').hide();
            // $('.eq-content-questions__parent').hide();
            // $('.eq-content-container__parent').hide();

             // Change tab index for page-2                    
             $('.page-2 .pop-up-finish-container').attr('tabindex', 0)
             $('.page-2 .pop-up-finish-container').focus()   
             $('.page-2 .js-see-dumy-results').attr('tabindex', 0)
             $('.page-2 .js-cancel-button').attr('tabindex', 0)        

            function pageTwoZoomModal() {

                if (isFirstPageTwoZoomModalCall) {
                    // Variable initialization only for the first function call
                    topValueSeeResultsButton = parseFloat($('.see-results-button').css('top'));
                    
                    isFirstPageTwoZoomModalCall = false;  // Set the flag to false to prevent reinitialization
                }

                var zoomFont = parseFloat($('.pcg-page-wrapper').css('font-size'));

                if( window.location.href.indexOf('/s4s/CustomPage/Index/222') > -1 ) {
                    if (zoomFont === 18) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton)+ 40) + 'px');
                    } else if (zoomFont === 20) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton) + 73) + 'px');
                    } else{
                        $('.see-results-button').css('top', parseFloat(topValueSeeResultsButton) + 'px');
                    }
                }

                if( window.location.href.indexOf('/s4s/CustomPage/Index/231') > -1){
                    if (zoomFont === 18) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton)+ 32) + 'px');
                    } else if (zoomFont === 20) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton) + 63) + 'px');
                    } else{
                        $('.see-results-button').css('top', parseFloat(topValueSeeResultsButton) + 'px');
                    }
                }

                if(window.location.href.indexOf('/s4s/CustomPage/Index/228') > -1 ) {
                    if (zoomFont === 18) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton)+ 33) + 'px');
                    } else if (zoomFont === 20) {
                        $('.see-results-button').css('top', (parseFloat(topValueSeeResultsButton) + 95) + 'px');
                    } else{
                        $('.see-results-button').css('top', parseFloat(topValueSeeResultsButton) + 'px');
                    }
                }


                

            
            }

            pageTwoZoomModal()

            $('body').on('click', '.js-accessibility-widget__font-size', function(){
                pageTwoZoomModal();
            })

            $('body').on('click', '.js-fontsize-normal', function(){
                pageTwoZoomModal();
            })
    
            $('body').on('click', '.js-fontsize-medium', function(){
                pageTwoZoomModal();
            })
    
            $('body').on('click', '.js-fontsize-large', function(){
                pageTwoZoomModal();
            })
            
        })

        $('.js-cancel-button').click(function(){
            $('.pop-up-finish-container').hide();
            $('.see-results-button').css('top', '');
            $('.see-results').hide();
            $('.see-results').removeClass('see-results-button');
            $('.edit-categories-top').removeClass('pop-up-main')
            $('.edit-categories').show();
            $('.cancel-button').hide()
            $('.eq-content-questions__parent').css('opacity', '1')
            $('.eq-content-container__parent').css('opacity', '1')
            $('.finish-preview-container').css('opacity', '1')
            $('.eq-progress-container__header').css('opacity', '1')
            // $('.eq-progress-container__header').parent().parent().css('pointer-events', 'auto')
            $('.form-main').css('pointer-events', 'auto')
            $('.form-header').css('pointer-events', 'auto')
            $('.form-main').css('opacity', '1')
            $('.form-header').css('opacity', '1')

            // $('button.blockBtns:contains("Next")').addClass('see-results');
            $('.see-results').text('Next');
    
        })

    }


    // Horizontal Click and Drag Scroll begins
    function clickDragscroll () {
        if ($('.progress-div').length > 0) {
            const slider = document.querySelector('.progress-div');
            let isDown = false;
            let startX;
            let scrollLeft;
    
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                // slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                // slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                // slider.classList.remove('active');
            });
            slider.addEventListener('mousemove', (e) => {
                if(!isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 2; //scroll-fast
                slider.scrollLeft = scrollLeft - walk;
            });
        }
    }

    

    

    // Horizontal Click and Drag Scroll ends


    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {

            $('#app').addClass('page-1');
            $('.formContainer').append('<button id="myBtn" title="Go to top"></button>')            
        },

        bindUIActions: function () {       
           

            $(document).ready ( function () {
                $("body").prepend('<div class="js-overlay tint10 block  spinner__overlay-23" style="width: 100%; height: 100%; z-index: 1000000; position: fixed">' + '<div class="spinner23" style="margin: 30% auto 0 auto;">' + "</div>" + "</div>");

                waitForElem(".page-1 .form-header__title").then(() => {

                // Hide continue with section
                $('.form-navigation-btns__container').hide()
                 

                // Add classes from previous version
                $('.form-navigation-btns__container').addClass('answer-btns');
                $('.form-navigation-btns__button').each(function(){
                    $(this).addClass('blockBtns')
                })
                // Change tab index for page-1
                $('.page-1 .eq-tile-checklist .form-checkbox__option').each(function(){
                    $(this).attr('tabindex', 0);
                })
                $('.page-1 .form-navigation-btns__btn_next').attr('tabindex', 0);
                $('.page-1.continue-with-container').attr('tabindex', 0);
                $('.page-1 .form-header__title').attr('tabindex', 0);
                $('.page-1 .form-header__description').attr('tabindex', 0);

                // Change h1 and h2 content for page-1
                $('.page-1 .form-header__title').text(`Let's begin`)
                $('.page-1 .form-header__description').text('What are you looking for support with? Choose from the categories below to tell us where you need help or advice. You can choose as many categories as you like')
                $('.page-1 .question-type-checkboxlist fieldset legend').hide()


                // Change tab index for page-2
                $('.page-2 .form-header__title').focus()
                $('.page-2 .js-progress-container').attr('tabindex', 0)

                $('.page-2 .edit-categories').attr('tabindex', 0)

                $('.page-2 .js-tab-buttons').each(function(){
                    $(this).attr('tabindex', 0);
                })


                $('.js-overlay').remove()

            });
               
                
            });

            


            // $('body').on('click', '.js-pcg-notification-pane__close-btn', function(){
            //     dynamicHeight();
            // })

            
            


            // // Updated items list

            // setTimeout(function() { 
            //     $('h3').each(function(){
            //         if ($(this).text()==="Eating and drinking") {
            //             $(this).next().html('<p>This section covers:<br>Choosing what to eat or drink,<br>Shopping for food and essentials,<br>Preparing meals and drinks,<br>Eating meals and drinking drinks.</p>')
            //         }

            //         if ($(this).text()==="Maintaining Personal Hygiene") {
            //             $(this).next().html('<p>This section covers:<br>Washing and bathing,<br>Keeping my teeth clean,<br>Grooming.</p>')
            //         }

            //         if ($(this).text()==="Managing Toilet Needs") {
            //             $(this).next().html('<p>This section covers:<br>Going to the toilet,<br>Soiling myself.</p>')
            //         }

            //         if ($(this).text()==="Getting Dressed") {
            //             $(this).next().html('<p>This section covers:<br>Choosing what to wear,<br>Washing and drying my clothes,<br>Buying new clothes,<br>Putting my clothes on.</p>')
            //         }

            //         if ($(this).text()==="Staying safe at home or in my community") {
            //             $(this).next().html('<p>This section covers:<br>Moving around my home safely,<br>Communicating outside my home,<br>Leaving my home,<br>Keeping my home secure.</p>')
            //         }

            //         if ($(this).text()==="Keeping my home clean and organised") {
            //             $(this).next().html('<p>This section covers:<br>Cleaning my home,<br>Organising my home/belongings,<br>Organising  my medication.</p>')
            //         }
                
            //     })
            // }, 500);    

            setInterval(function () {

                $('.question-type-checkboxlist p').each(function(){

                    if ($(this).text() === 'I have difficulty/I need help with:') {
                        $(this).parent().parent().parent().next().addClass('info-message')
                    }        
                    
                })

                var elements = document.getElementsByClassName("question-type-label");

                for (var i = 0; i < elements.length; i++) {

                    var text = elements[i].innerText;

                    if (text === 'Please email enquiries@towerhamletsconnect.org') {
                        elements[i].classList.add("info-message");
                    }
                    
                }

                $('.question-type-label p').each(function(){


                    if ($(this).is(':contains("If you are at imminent risk of danger you can:")')) {
                        $(this).parent().addClass('info-message')
                    }        

                    if ($(this).text() === 'Please contact the Adult Social Care Team that is supporting you.') {
                        $(this).parent().parent().addClass('info-message')
                    }        
                    
                    if ($(this).text() === 'Please note, you may not be eligible for support from Adult Social Care.') {
                        $(this).parent().parent().addClass('info-message')
                    }  
                })

                $('.question-type-label h3').each(function(){

                    if ($(this).text() === 'An advisor will contact you within two weeks to discuss your support needs in more detail. In the meantime, if your situation worsens please contact the service on 0300 303 6070.') {
                        $(this).next().hide()
                    }        
                    
                })

            
            }, 200); // check every 200ms        
            
            
            // Page 1 call to actions
            $('body').on('click', '.eq-tile-checklist label', function(){
                const heading = $(this).find('h3').text();
                const index = $(this).closest('.form-checkbox__option').index() + 1;

                // $(this).parent().toggleClass('selected');

                if ( $(this).parent().find('input').is(":checked") ) {
                    $(this).parent().removeClass('selected');
                } else {
                    $(this).parent().addClass('selected');
                }
            
                // Remove category
                if ( $(this).parent().find('input').is(":checked") ) {
                    currentState.topLevelCategories = currentState.topLevelCategories.filter(function( obj ) {
                        return obj.name !== heading;
                    });
                
                // Add to category to the currentState object 
                } else {
                    currentState.topLevelCategories.push({name: heading, index: index});
                }

                // Sort array by index
                currentState.topLevelCategories.sort(function(a, b) {
                    return a.index - b.index;
                });

                printOutCategoriesInFooter();

                 // Change tab index for page-1
                $('.page-1 .form-navigation-btns__btn_next').attr('tabindex', 0);
                $('.page-1 .continue-with-container').attr('tabindex', 0);

                 // Hide continue with section         
                if ($('.js-continue-with span').length === 0) {
                    $('.form-navigation-btns__container').hide()
                } else {
                    $('.form-navigation-btns__container').show()
                }

            });

            // Change tab index for page-1
            $('body').on('keyup', '.page-1 .form-checkbox__option', function(e){
                if (e.which === 13) {
                    $(this).children('label').click()
                }
            });


            $('body').on('click', '.js-progress-container', function(){
                clickDragscroll()
            })

            


            // Pagination
            $('body').on('click', '.answer-btns button', function(){

                // Go to page 1
                if ( $(this).text().match('Previous') ) {
                    if ( $('#app').hasClass('page-2') ) {
                        $('#app').removeClass('page-2');
                        $('#app').addClass('page-1');

                        pageOneActions();
                    }
                }

                // Go to page 2
                if ( $(this).text().match('Next') ) {
                    if ( $('#app').hasClass('page-1') ) {
                        $('#app').removeClass('page-1');
                        $('#app').addClass('page-2');

                        pageTwoActions();   
                    }
                }

                // Go to page 3 - dumy results page
                if ( $(this).text().match('Yes, see my results') ) {

                    // Hide 'Finish and see results' button
                    $(this).hide();
                    if ( $('#app').hasClass('page-2') ) {
                        $('#app').removeClass('page-2');
                        $('#app').addClass('page-dumy-results');

                        pageDumyResultsActions();
                    }
                }


                // Go to page 3-1 - assessment results page
                if ( $(this).text().match('Complete your online assessment') ) {
                    // Hide 'Finish and see results' button
                    // $(this).hide();
                    if ( $('#app').hasClass('page-dumy-results') ) {
                        // if ($('.field-validation-error').length == 0) {
                        //     $('.page-title').hide();
                        //     $('.side-section').hide();
                        //     $('#app').removeClass('page-dumy-results');
                        //     $('#app').addClass('page-assessment-results');
                        //     // pageResultsActions();
                        //     pageAssessmentResultsActions()
                        //     // $('.see-results').hide();
                        //     // $('.see-results').next().show();

                        // } else 
                        
                        if ($('.forms-feedback').length == 0) {
                            $('.page-title').hide();
                            $('.side-section').hide();
                            $('#app').removeClass('page-dumy-results');
                            $('#app').addClass('page-assessment-results');
                            // pageResultsActions();
                            pageAssessmentResultsActions()
                            // $('.see-results').hide();
                            // $('.see-results').next().show();
                        }
                        
                    }
                }


                // Go to page 3-2 - assessment results page - 2
                // if ( $(this).text().match('Complete your online assessment') ) {
                //     // Hide 'Finish and see results' button
                //     // $(this).hide();
                //     if ( $('#app').hasClass('page-dumy-results') ) {
                //         if ($('.field-validation-error').length == 0) {
                //             $('#app').removeClass('page-dumy-results');
                //             $('#app').addClass('page-assessment-results');
                //             pageResultsActions();
                //             // pageAssessmentResultsActions()
                //             $('.see-results').hide();
                //             $('.see-results').next().show();
                //         }
                        
                //     }
                // }

                // Go to page 4 - results page
                if ( $(this).text().match('Finish') ) {
                           
                    $('body').prepend(
                        '<div class="js-overlay block" style="width: 100%; height: 100%; z-index: 1000000; position: fixed; background: #ffffff">' +
                            '<div class="spinner23" style="margin: 30% auto 0 auto;"></div>' +
                        '</div>'
                    );

                    // Hide 'Finish and see results' button
                    // $(this).hide();
                    if ( $('#app').hasClass('page-dumy-results') ) {
                        if ($('.forms-feedback').length == 0) {
                            $('#app').removeClass('page-dumy-results');
                            $('#app').addClass('page-results');
                            $('.js-overlay').remove()
                            pageResultsActions();
                        } else {
                            $('#app').addClass('page-dumy-results');
                            $('.js-overlay').remove()
                        }
                        

                        
                    } else  if ( $('#app').hasClass('page-assessment-results') ) {

                                if ($('.forms-feedback').length == 0) {
                                    $('#app').removeClass('page-assessment-results');
                                    $('#app').addClass('page-results');
                                    $('.js-overlay').remove()

                                    pageResultsActions();
                                }
                       
                    }
                }

            });

            // Tabs
            $('body').on('click', '.eq-tabs', function(){
                $(this).toggleClass('selected');
            });


            // Scroll to top button
            // Get the button:
            $('body').on('click', '#myBtn', function(){
                topFunction();
            });

            let mybutton = document.getElementById("myBtn");

            // When the user scrolls down 20px from the top of the document, show the button
            // window.onscroll = function() {scrollFunction()};

            function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
            }

            // When the user clicks on the button, scroll to the top of the document
            function topFunction() {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            }

        },

        unload: function () {},
    };

    Attributes.init();
})();